import { CcRequirementStatus } from "server/models"

export type CcRequirementStatusValidation = { [key in keyof CcRequirementStatus]?: string}
export interface CcRequirementStatusList { [statusId: number]: CcRequirementStatus }

export interface CcRequirementStatusState {
    statusList: CcRequirementStatusList
    statusIds: readonly number[]
    statusEdit: CcRequirementStatus

    reloadList: boolean
    reloadEdit: boolean
}

export const CC_REQUIREMENT_STATUS_LIST = "CC_REQUIREMENT_STATUS_LIST"
export const CC_REQUIREMENT_STATUS_IDS = "CC_REQUIREMENT_STATUS_IDS"
export const CC_REQUIREMENT_STATUS_EDIT = "CC_REQUIREMENT_STATUS_EDIT"

export const CC_REQUIREMENT_STATUS_RELOAD_LIST = "CC_REQUIREMENT_STATUS_RELOAD_LIST"
export const CC_REQUIREMENT_STATUS_RELOAD_EDIT = "CC_REQUIREMENT_STATUS_RELOAD_EDIT"
